// extracted by extract-css-chunks-webpack-plugin
module.exports = {"document-link":"document-link_Z9nxa","document-link__sw-link":"document-link__sw-link_1oYIJ","document-link_inverted":"document-link_inverted_1mcJw"};